import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Observable, of } from 'rxjs';
import { NavigationService } from '../../../core/service/navigation.service';
import { InvoiceReminderService } from '../data/invoice-reminder.service';
import { InvoiceReminder } from '../../model/invoice-reminder';
import { InvoiceReminderCommand } from '../../command/invoice-reminder';

@Injectable()
export class OpenInvoiceFromReminderCommandHandler implements ICommandHandler {
  constructor(
    private _service: InvoiceReminderService,
    private _navigation: NavigationService
  ) {}

  canExecute(command: Command): boolean {
    if (!command || !command.context) return false;
    return command.id == InvoiceReminderCommand.openInvoice;
  }

  execute(command: Command): Observable<boolean> {
    if (command instanceof Command) {
      this._navigation.navigate(['invoices', 'edit', (<InvoiceReminder>command.context).invoiceId]);
      return of(true);
    }
  }
}
